/**
 * Track the epoch timestamp of the last successful login.
 * Used to suppress stale 401s from requests that started before login completed.
 */

let lastLoginSuccessAt: number | null = null;

/**
 * Mark the current time as the last successful login time.
 * Call this after a successful login to track when authentication succeeded.
 */
export function setLastLoginSuccessAt(): void {
  lastLoginSuccessAt = Date.now();
}

/**
 * Get the timestamp (epoch milliseconds) of the last successful login.
 * Returns null if no login has been recorded in this session.
 */
export function getLastLoginSuccessAt(): number | null {
  return lastLoginSuccessAt;
}
